import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isMobile: /(iPhone|iPad|Android)/gi.test(navigator.userAgent),
        isIE: /(MSIE|Trident)/gi.test(navigator.userAgent),
        region: environment.region,
        appType: null,
        userData: undefined,
        services: [],
        service: undefined,
        categories: [],
        category: {},
        productCrumb: '',
        sandboxMode: false,
    },
    actions: {
        getServices({ commit }, locale) {
            return this._vm.$shopAPI.getServiceList(locale).then((services) => {
                commit('setServices', services);
                return services;
            });
        },
        getCategories({ commit, state }, locale) {
            return this._vm.$shopAPI.getCategoryList(locale, state.service.service_group_code).then((categories) => {
                const result = [
                    {
                        no: 0,
                        name: 'all',
                    },
                ].concat(categories);
                commit('setCategories', result);
                return result;
            });
        },
    },
    mutations: {
        setAppType(state, payload) {
            state.appType = payload;
        },
        setUserData(state, payload) {
            state.userData = payload;
        },
        setServices(state, payload) {
            state.services = payload;
        },
        setService(state, payload) {
            state.service = payload;
        },
        setCategories(state, payload) {
            state.categories = payload;
        },
        setCategory(state, payload) {
            state.category = payload;
        },
        setProductCrumb(state, payload) {
            state.productCrumb = payload;
        },
        clearProductCrumb(state) {
            state.productCrumb = '';
        },
        resetCategories(state) {
            state.categories = [];
            state.category = {};
        },
        enableSandboxMode(state) {
            state.sandboxMode = true;
        },
    },
});
